module.exports = __webpack_public_path__ + "static/media/thirdWitness.22747be2.webp";